import { ReactNode } from 'react';

import Layout from '../components/Layout';

interface IProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: IProps) => {
  return <Layout>{children}</Layout>;
};

export default PrivateRoute;
